export default __webpack_public_path__ + "static/media/icn-save-white.98441428.svg";